import React from 'react';
import { mdiApple, mdiCalendarOutline, mdiGoogle, mdiMicrosoftOutlook, mdiYahoo } from '@mdi/js';

// Material Design Icons ship path data rather than components, which is what
// makes them usable here: this package is consumed as raw source by a Next.js
// app with no svg loader, so an imported .svg would not build.
const ICON_PATHS = {
  apple: mdiApple,
  google: mdiGoogle,
  outlookcom: mdiMicrosoftOutlook,
  yahoo: mdiYahoo,
  ical: mdiCalendarOutline,
};

const ProviderIcon = ({ providerId, className }) => {
  const path = ICON_PATHS[providerId];

  if (!path) return null;

  // aria-hidden: the row's accessible name is the provider name on its own.
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <path fill="currentColor" d={path} />
    </svg>
  );
};

export default ProviderIcon;
